import {IParams, RecursosController} from "../recursos";

declare global {
    interface Window {
        Twitch: any;
    }
}

export class TwitchController extends RecursosController {

    /* INSTANCE */
    public static instance: TwitchController;

    /* STATIC */
    public static override async build(): Promise<void> {
        TwitchController.instance = new this();
        RecursosController.instances.push(TwitchController.instance);
    }

    constructor() {
        super();
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='twitch-head'], [class*='twitch-body'], [class*='twitch-live']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement) : Promise<void> {
        const params = JSON.parse(item.getAttribute('data-lazy')!.replace(/'/g,"\""));
        const urls: IParams[] = [{name: "script-twitch", value: "https://player.twitch.tv/js/embed/v1.js"}];
        const promesas = await this.initPromises(urls);
        await Promise.all(promesas).then(async ()=>{
            const id = item.id;
            if (this.providerItems[id]) this.providerItems[id].destroy();
            if (params.channel) {
                this.providerItems[id] = new window.Twitch.Player(id, {
                    channel: params.channel,
                    muted: true
                });
            }
            if (params.id) {
                this.providerItems[id] = new window.Twitch.Player(id, {
                    video: params.id,
                    muted: true
                });
            }
        });
    }

}
